module.exports = __webpack_public_path__ + "static/media/ic_auth_bank.beca9e76.svg";